<template>

    <section class="c-settings_custom_fields">
        <h3>Pola niestandardowe</h3>
        <form-desc>Możesz dodać własne pola, które pojawią się w formularzu przebiegu wizyty. Maksymalnie możesz dodać
            <strong>{{ maxFields }}</strong> pól.
        </form-desc>
        <form-input
            label="Dodaj pole"
            v-model="newField"
            @click="storeField"
            speech-to-text
            btn="green"
            btn-label="Dodaj"
            btn-has-loader
            :btn-loading="isLoading"
            :error="inputError">
        </form-input>
        <v-table class="c-settings_offices__table" v-if="pht.custom_fields && pht.custom_fields.length">
            <thead>
            <th>Nazwa</th>
            <th>Akcje</th>
            </thead>
            <tbody>
            <tr v-for="field in pht.custom_fields" :key="field">
                <td>{{ field }}</td>
                <td class="c-settings_offices__table-actions">
                    <v-btn
                        type="icon"
                        icon="edit"
                        title="Edytuj pacjenta"
                        @click="$refs.settingsCustomFieldEditModal.$emit('open', field)">
                    </v-btn>
                    <v-btn
                        type="icon"
                        icon="delete"
                        title="Usuń pacjenta"
                        @click="deleteField(field)">
                    </v-btn>
                </td>
            </tr>
            </tbody>
        </v-table>
        <p class="c-settings_custom_fields__empty" v-else>Brak pól</p>

        <settings-custom-field-edit-modal ref="settingsCustomFieldEditModal"
                                          @ok="updateField"></settings-custom-field-edit-modal>
    </section>

</template>


<script>

import {mapGetters} from 'vuex'

import SettingsCustomFieldEditModal from 'Components/Settings/SettingsCustomFieldEditModal'
import {FormRow, FormInput, FormDesc} from 'Components/Form'
import VTable from 'Components/VTable'
import VBtn from 'Components/VBtn'

export default {

    name: 'SettingsCustomFields',

    computed: {
        ...mapGetters(['pht'])
    },

    data() {
        return {
            maxFields: 10,
            inputError: null,
            newField: '',
            isLoading: false
        }
    },

    methods: {
        storeField() {
            this.inputError = null

            this.newField = this.newField.trim()

            if (this.newField === '') {
                this.inputError = 'Podaj nazwę pola niestandardowego.'
                return false
            }

            if (this.getId(this.newField) !== false) {
                this.inputError = 'Pole o takiej nazwie już istnieje.'
                return false
            }

            if (this.pht.custom_fields.length + 1 > this.maxFields) {
                this.inputError = `Maksymalnie możesz dodać ${this.maxFields} pól.`
                return false
            }

            this.pht.custom_fields.push(this.newField)
            this.isLoading = true
            this.saveFields().then(() => {
                this.newField = ''
            })

        },
        deleteField(field) {
            this.inputError = null
            var fieldId = this.pht.custom_fields.indexOf(field)
            this.pht.custom_fields.splice(fieldId, 1)
            this.saveFields()
        },
        updateField(oldField, field, closeModal) {
            this.inputError = null

            if (field === oldField) {
                closeModal()
                return
            }

            if (this.pht.custom_fields.indexOf(field) !== -1) {
                this.$alert.error('Pola niestandardowe', 'Pole o takiej nazwie już istnieje')
                closeModal()
                return
            }

            var fieldId = this.pht.custom_fields.indexOf(oldField)
            this.pht.custom_fields[fieldId] = field.trim()
            this.saveFields().then(() => {
                closeModal()
            })
        },
        saveFields() {
            return this.$store.dispatch('PHT_CUSTOM_FIELDS_UPDATE').then((result) => {
            }).then(() => {
                this.isLoading = false
            }).catch((error) => {
                this.isLoading = false
                this.$alert.error('Pola niestandardowe', error.response.data.message)
            })
        },
        getId(name) {
            const len = this.pht.custom_fields.length
            for (let i = 0; i < len; i++) {
                if (this.pht.custom_fields[i] === name)
                    return i
            }
            return false
        }
    },

    components: {
        SettingsCustomFieldEditModal,
        FormRow,
        FormDesc,
        FormInput,
        VBtn,
        VTable
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-settings_custom_fields {
    &__empty {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 1.2rem;
        margin-top: 2.5rem;
        margin-bottom: 0;
        width: 100%;
        text-align: center;
    }
}

</style>
